export default "__VITE_ASSET__qWrAQvoV__"